
const FlexibleSolutionsSection = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Flexible Training Solutions
          </h2>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed mb-8">
            <p>
              Our training solutions are adaptable to meet the needs of various clients. We offer:
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-6 mb-8">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-blue-900 mb-3">
                <i className="ri-building-line mr-2"></i>
                Onsite Training
              </h3>
              <p className="text-gray-700">
                Conduct employee safety at your workplace for convenience and relevance.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-blue-900 mb-3">
                <i className="ri-map-pin-line mr-2"></i>
                Offsite Training
              </h3>
              <p className="text-gray-700">
                Available at our facilities or a location of your choice, such as your annual meeting venue.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-blue-900 mb-3">
                <i className="ri-calendar-line mr-2"></i>
                Monthly Safety Meetings
              </h3>
              <p className="text-gray-700">
                Regularly scheduled training sessions to ensure continuous compliance.
              </p>
            </div>
            
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-bold text-blue-900 mb-3">
                <i className="ri-team-line mr-2"></i>
                Partnership Programs
              </h3>
              <p className="text-gray-700">
                Long-term partnerships to serve as your fractional safety director, providing ongoing guidance and support.
              </p>
            </div>
          </div>
          
          <div className="space-y-6 text-lg text-gray-700 leading-relaxed">
            <p>
              HP Inc Consultant Services offers training in various formats to accommodate your company's needs. Our training is available in both English and Spanish, and we can work with interpreters to accommodate other languages as needed. For clients who require ongoing support, we offer retainer-based partnerships where we serve as your fractional safety director. In this role, we guide training selection, conduct regular safety meetings and site inspections, and help you develop and maintain a comprehensive safety program.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlexibleSolutionsSection;